import { uniq } from 'lodash'
import { toast } from '@opallabs/lapidary'
import type { AddToBoardResponseData, SelectionMeta } from '../types'
import {
  AddToBoardDuplicateFailureToast,
  AddToBoardFailureToast,
  defaultAddToBoardFailureOptions,
} from './FailureToasts'
import {
  AddToBoardSuccessToast,
  UnscheduleSuccessToast,
  defaultUnscheduleSuccessOptions,
  defaultAddToBoardSuccessOptions,
} from './SuccessToasts'

export {
  AddToBoardSuccessToast,
  AddToBoardDuplicateFailureToast,
  AddToBoardFailureToast,
  defaultAddToBoardFailureOptions,
  defaultAddToBoardSuccessOptions,
}

export const handleAddToBoardToasts = ({
  data,
  selectionMeta,
  onActionClick,
  resourceDisplayName = 'moment',
  workspaceSlug,
}: {
  data: AddToBoardResponseData
  selectionMeta?: SelectionMeta
  onActionClick?: (failedMomentIds: string[]) => void
  resourceDisplayName?: string
  workspaceSlug: string
}) => {
  if (data.successes.length) {
    const successIds = data.successes.map(({ moment_id }) => moment_id)
    const successMoments = selectionMeta?.moments?.filter(({ id }) =>
      successIds.includes(id)
    )

    if (successMoments) {
      toast(
        (props) => (
          <AddToBoardSuccessToast
            changes={selectionMeta?.boards}
            moments={successMoments}
            resourceDisplayName={resourceDisplayName}
            workspaceSlug={workspaceSlug}
            {...props}
          />
        ),
        defaultAddToBoardSuccessOptions
      )
    }
  }

  if (data.failures.length) {
    const duplicateFailures = data.failures.filter(
      (error) => error.status_code === 422
    )
    const otherFailures = data.failures.filter(
      (error) => error.status_code !== 422
    )

    if (duplicateFailures.length) {
      // If a moment fails for multiple requests, we'll only display one error per moment
      const failedMomentIds = uniq(
        duplicateFailures.map(({ moment_id }) => moment_id)
      )

      toast(
        (props) => (
          <AddToBoardDuplicateFailureToast
            momentCount={failedMomentIds.length}
            onActionClick={
              onActionClick ? () => onActionClick(failedMomentIds) : undefined
            }
            resourceDisplayName={resourceDisplayName}
            {...props}
          />
        ),
        {
          ...defaultAddToBoardFailureOptions,
          toastId: 'add-to-bard-duplicate-failure',
        }
      )
    }

    if (otherFailures.length) {
      const failedMomentIds = uniq(
        otherFailures.map(({ moment_id }) => moment_id)
      )

      toast(
        (props) => (
          <AddToBoardFailureToast
            momentCount={failedMomentIds.length}
            onActionClick={
              onActionClick ? () => onActionClick(failedMomentIds) : undefined
            }
            resourceDisplayName={resourceDisplayName}
            {...props}
          />
        ),
        defaultAddToBoardFailureOptions
      )
    }
  }
}

export const handleUnscheduleToast = (momentTitle: string) => {
  toast(
    (props) => <UnscheduleSuccessToast momentTitle={momentTitle} {...props} />,
    defaultUnscheduleSuccessOptions
  )
}
